import angular from "angular";
import './dom.css';

/*******************************************************************************
 * @ngdoc    directive
 * @module   csm.books.dom
 * @name     csm.books.dom.directive:currencyInput
 * @restrict A
 * @property {String} currencySymbol  Currency symbol, default='$'.
 * @description
 * Attribute for text input to be formatted and parsed as currency. Uses the
 * `currency` filter and will format the input with the default symbol if an
 * alternative symbol is not supplied.
 *******************************************************************************/
/* @ngInject */ export function CurrencyInputDirective($filter) {
  return {
    scope: { currencySymbol: '<' },
    require: 'ngModel',
    link: function (scope, elem, attrs, ngModel) {
      /*-----------------------------------------------------*/
      /* Add formatter to format the input using the         */
      /* currency' filter with the currency symbol supplied. */
      /*                                                     */
      /* Note: `currency-symbol=""` will be converted by the */
      /* browser to `currency-symbol`. If the attribute is   */
      /* found without a value, the empty string is assumed. */
      /*-----------------------------------------------------*/
      var formatter = function (modelValue) {
        return $filter('currency')(
          modelValue,
          !angular.isUndefined(attrs.currencySymbol)
            ? scope.currencySymbol || ''
            : undefined
        );
      };
      ngModel.$formatters.unshift(formatter);

      /*-----------------------------------------------*/
      /* Add parser to parse the input formatted as    */
      /* currency and update the formatted text input. */
      /*-----------------------------------------------*/
      ngModel.$parsers.unshift(function (viewValue) {
        return parseFloat(viewValue.replace(/[^0-9\.\-]/g, ''));
      });

      /*-------------------------------------------------------------------------*/
      /* Update the element value with the formatted model value when            */
      /* caret leaves the field.                                                 */
      /*                                                                         */
      /* Note: `ngModelOptions.updateOn:'blur'` does not work in angular-ui-grid */
      /*       since it destroys the editor element before the `blur` is seen.   */
      /*                                                                         */
      /* TODO: In the latest version (1.7) of AngularJS, this can be done with a */
      /* TODO: call to `ngModel.$processModelValue()`.                           */
      /*-------------------------------------------------------------------------*/
      elem.bind('blur', function () {
        elem.val(formatter(ngModel.$modelValue));
      });
    }
  }
}
